<div class="bg-white p-6">
  <div class="flex flex-col">
    <button color="primary" mat-button class="w-full text-xl">Resources</button>
    <mat-list>
      @for (item of navItems; track $index) {
      <mat-list-item
        matRipple
        class="nav-item"
        (click)="item.active = true; setActiveNavItem($index)"
        [routerLink]="item.id"
        [lines]="item.lines"
      >
        <mat-icon class="nav-item__icon" color="primary" matListItemAvatar>{{
          item.icon
        }}</mat-icon>
        <span matListItemTitle>{{ item.name }}</span>
        {{ item.secondaryText }}
      </mat-list-item>
      }
    </mat-list>
  </div>
</div>
